import { useForm } from "@inertiajs/react";
import type { FormEvent } from "react";
import TextField from "@/components/forms/TextField";
import Layout from "@/components/Layout";

type NewProps = {
  form: {
    query: string;
  };
};

export default function New({ form }: NewProps) {
  const { data, errors, processing, post, setData } = useForm(form);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    post("/impersonate", { preserveState: true });
  }

  return (
    <Layout title="Impersonate">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6">
          <h1 className="mb-1 text-2xl font-semibold">Impersonate a user</h1>
          <p className="text-gray-500">Enter a user ID or email. Admins only.</p>
        </div>

        <form onSubmit={handleSubmit} className="card">
          <div className="card-body">
            <TextField
              error={errors.query}
              label="User ID or email"
              onChange={(query) => setData("query", query)}
              placeholder="user@example.com or uuid"
              required
              value={data.query}
            />

            <div className="mt-8 flex justify-end border-t border-gray-200 pt-6">
              <button type="submit" className="btn btn-primary" disabled={processing}>
                {processing ? "Starting..." : "Impersonate"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Layout>
  );
}
